var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.003 512.003",
    height: 512,
    viewBox: "0 0 512.003 512.003",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m381.044 58.039h-68.562c-8.284 0-15 6.716-15 15 0 9.311-5.842 17.806-14.535 21.138l-27.442 10.519c-.001 0-.002.001-.003.001l-118.896 45.575h-87.327c-27.173 0-49.279 22.107-49.279 49.279v40.967c0 27.172 22.106 49.279 49.279 49.279h6.835v149.167c0 8.284 6.716 15 15 15h68.562c8.284 0 15-6.716 15-15v-143.135l100.753 39.212c.002.001.005.001.007.002l27.485 10.697c8.845 3.442 14.56 11.799 14.56 21.29 0 8.284 6.716 15 15 15h68.562c8.284 0 15-6.716 15-15v-293.991c.001-8.284-6.715-15-14.999-15zm-225.347 205.995v-88.952l90.173-34.565v158.611zm-125.697-23.516v-40.967c0-10.63 8.648-19.279 19.279-19.279h76.418v79.525h-76.418c-10.631 0-19.279-8.648-19.279-19.279zm56.114 183.446v-134.167h38.562v134.167zm279.93-71.934h-40.695c-4.515-15.451-15.918-28.165-31.546-34.247l-17.933-6.979v-181.786l17.814-6.829c15.403-5.905 26.955-18.779 31.582-34.15h40.777v263.991z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.202 235.748h47.798c8.284 0 15-6.716 15-15s-6.716-15-15-15h-47.798c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.378 313.636-47.798-22.453c-7.499-3.521-16.432-.299-19.954 7.199s-.3 16.432 7.198 19.954l47.798 22.453c2.062.968 4.231 1.427 6.368 1.427 5.634 0 11.032-3.189 13.586-8.626 3.523-7.498.3-16.432-7.198-19.954z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.212 151.739c2.136 0 4.307-.458 6.368-1.427l47.798-22.453c7.498-3.522 10.721-12.456 7.198-19.954-3.522-7.5-12.458-10.722-19.954-7.199l-47.798 22.453c-7.498 3.522-10.721 12.456-7.198 19.954 2.554 5.437 7.952 8.626 13.586 8.626z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.4403eea88c3dcbd3522bf840e1d01344.svg";
export { ForwardRef as ReactComponent };